import authSagas from 'store/auth/saga'
import certificatesSaga from 'store/certificates/saga'
import countriesSaga from 'store/countries/saga'
import customersSaga from 'store/customers/saga'
import { all } from 'redux-saga/effects'

export default function* rootSaga(): Generator {
  yield all([...authSagas])
  yield all([...certificatesSaga])
  yield all([...customersSaga])
  yield all([...countriesSaga])
}
